import { buildAmplitudeClient } from "./custom-amplitude-client.303eb70a37e9.js";
import"./backdrop-dialog.eee1318ab04a.js";

export class PriceVerification {
  constructor() {
    this.amplitudeClient = buildAmplitudeClient();

    document.addEventListener("click", (e) => {
      const button = e.target.closest(".price-verification");
      if (button) {
        const dataset = button.dataset;
        const page = dataset.page;
        const properties = {
          service_code: dataset.service,
          provider_id: dataset.providerid,
        };
        this.amplitudeClient.trackEngageVerifyPrice(page, properties);
        document.getElementById("price-verification-modal")?.showModal();
      }
    });
  }
}
